import { colours } from '@qflow/theme'
import styled from 'styled-components'

export function TemplateNameIndicator({ estimatedAccuracy }) {
  const colour =
    estimatedAccuracy != null
      ? estimatedAccuracy >= 88
        ? colours.GREEN
        : estimatedAccuracy >= 80
          ? colours.AMBER
          : colours.RED
      : colours.BORDER_GREY

  return (
    <TrafficLightIcon $colour={colour}>
      {estimatedAccuracy ? `${estimatedAccuracy}` : '0'}
    </TrafficLightIcon>
  )
}

export const TrafficLightIcon = styled.span`
  min-width: 18px;
  min-height: 18px;
  flex-shrink: 0;

  color: ${colours.WHITE};
  background-color: ${({ $colour }) => $colour};
  border-radius: 50%;
  display: inline-block;
  margin: 1px 6px 1px 0;
  padding: 1px 0 1px;
  font-size: 11px;
  text-align: center;
`
